module.exports = __webpack_public_path__ + "static/media/services_moving.e04e29cf.jpg";